<template>
  <div class="lpos-data wrapper">
    <div class="title-block">
      <span>Список участков</span>
    </div>

    <div class="btn-row" v-if="!addMode">
      <div class="control-btn-row">
        <button @click="enableAddMode" :disabled="!actLpoIsDraft">
          Добавить участок
        </button>
        <button @click="goToGrouping" :disabled="!actLpoIsDraft">
          Сгруппировать с существующими
        </button>
        <button
          @click="excludeFromGroup"
          :disabled="
            actLpoList.length === 1 ||
              !selectedList.length ||
              actLpoList.length === selectedList.length ||
              !actLpoIsDraft
          "
        >
          Исключить из группы
        </button>
      </div>
    </div>

    <div class="add-block" v-if="addMode">
      <div class="grid">
        <div>
          <span class="select-title">Квартал</span>
          <custom-p-select
            v-model="selectedArea"
            :options="areaList"
            :disabled="!actLpoIsDraft"
          />
        </div>

        <div>
          <span class="select-title">Выдел</span>
          <custom-p-select
            v-model="selectedSection"
            :options="sectionList"
            :disabled="!actLpoIsDraft"
          />
        </div>

        <div>
          <custom-p-checkbox
            v-model="isLpSection"
            label="Лп выдел"
            :disabled="!actLpoIsDraft"
          />
          <input
            v-if="isLpSection"
            v-model="selectedSectionLp"
            class="custom-input"
            :disabled="!actLpoIsDraft"
          />
        </div>
      </div>
      <div class="add-block-btn-row">
        <button @click="disableAddMode" :disabled="!actLpoIsDraft">
          Закрыть
        </button>
        <button @click="createLpo" :disabled="!actLpoIsDraft">Создать</button>
      </div>
    </div>

    <table class="lpos-table">
      <thead>
        <tr>
          <th>Лесничество</th>
          <th>Участковое лесничество</th>
          <th>Урочище / дача</th>
          <th>Квартал</th>
          <th>Выдел</th>
          <th>Лп выдел</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="lpo in actLpoList" :key="lpo.lpo_id">
          <td>{{ lpo.forestry }}</td>
          <td>{{ lpo.localforestry }}</td>
          <td>{{ lpo.subforestry }}</td>
          <td>{{ lpo.area }}</td>
          <td>{{ lpo.section }}</td>
          <td>{{ lpo.section_lp }}</td>
          <td><button @click="goToLpo(lpo)">перейти к обследованию</button></td>
          <td>
            <button
              @click="openRemoveConfirmation(lpo)"
              :disabled="!actLpoIsDraft"
            >
              удалить обследование
            </button>
          </td>
          <td>
            <custom-p-checkbox
              v-model="selectedList"
              multiple
              :multipleValue="lpo"
              :disabled="!actLpoIsDraft"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <custom-p-confirmation
      v-model="removeConfirmationOpen"
      title="Удаление обследования"
      message="Вы уверены, что хотите удалить данное обследование?"
      confirmLabel="Удалить"
      rejectLabel="Отмена"
      @confirm="removeLpo"
      confirmButtonClass="p-button-danger"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_AREAS = ROOT_API + "address/get_areas.php";
const GET_SECTIONS = ROOT_API + "address/get_sections.php";

import processJSON from "@/lib/processJSON";

export default {
  name: "ActLpoList",
  data() {
    return {
      addMode: false,

      forestry: null,

      selectedArea: null,
      selectedSection: null,
      isLpSection: false,
      selectedSectionLp: null,

      areaList: [],
      sectionList: [],

      selectedList: [],

      lpoToRemove: null,
      removeConfirmationOpen: false,
    };
  },
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
      actLpoList: (state) => state.actLpoList,
    }),
  },
  watch: {
    selectedArea(area) {
      if (area) {
        this.getSectionList();
      }
    },
  },
  methods: {
    openRemoveConfirmation(lpo) {
      this.lpoToRemove = lpo;
      this.removeConfirmationOpen = true;
    },

    excludeFromGroup() {
      this.$store
        .dispatch("lpoData/excludeFromGroup", this.selectedList)
        .then((res) => {
          return this.getActLpoList().then((res) => {
            /* если текущего обследования больше нет в группе обследований, переходим к другому обследованию */
            if (
              !this.actLpoList.find(
                (lpo) => lpo.lpo_id === this.currentLpo.lpo_id
              )
            ) {
              const route_obj = {
                name: "act-lpo-list",
                params: {
                  lpo_id: this.actLpoList[0].lpo_id,
                },
              };
              this.$router.push(route_obj);
            }
          });
        })
        .finally(() => {
          this.selectedList = [];
        });
    },

    removeLpo(lpo) {
      this.removeLpoFromList(this.lpoToRemove)
        .then((res) => {
          /* если удалили удениственное обследование в группе - переходим к журналу */
          if (
            this.actLpoList.length === 1 &&
            this.actLpoList[0].lpo_id === this.lpoToRemove.lpo_id
          ) {
            const route_obj = {
              name: "journal-lpo",
            };
            this.$router.push(route_obj);
          } else {
            return this.getActLpoList().then((res) => {
              /* если удалили текущее обследование, переходим к другому обследованию */
              if (this.lpoToRemove.lpo_id === this.currentLpo.lpo_id) {
                const route_obj = {
                  name: "act-lpo-list",
                  params: {
                    lpo_id: this.actLpoList[0].lpo_id,
                  },
                };
                this.$router.push(route_obj);
              }
            });
          }
        })
        .finally(() => {
          this.lpoToRemove = null;
        });
    },

    goToGrouping() {
      // return;

      const lpo = this.actLpoList[0];

      // const filter = `
      // 	fo_id=''${lpo.fo_id}'' and
      // 	region_id=''${lpo.region_id}'' and
      // 	forestry_id=''${lpo.forestry_id}'' and
      // 	localforestry_id=''${lpo.localforestry_id}'' and
      // 	user_id=''${this.$store.state.auth.userId}''`;

      const filter = `
					fo_id=''${lpo.fo_id}'' and
					region_id=''${lpo.region_id}'' and
					forestry_id=''${lpo.forestry_id}'' and
					localforestry_id=''${lpo.localforestry_id}''`;

      this.$router.push({ name: "grouping-with-existing", params: { filter } });
    },

    enableAddMode() {
      this.getAreaList();

      this.addMode = true;
    },

    disableAddMode() {
      this.addMode = false;

      this.selectedArea = null;
      this.selectedSection = null;
      this.selectedSectionLp = null;
      this.isLpSection = false;

      this.areaList = [];
      this.sectionList = [];
    },

    goToLpo(lpo) {
      /*
					обновление текущего обследования происходит
					в LpoData.vue в хуке роутера beforeRouterUpdate
				*/
      const route_obj = {
        name: "lpo",
        params: {
          lpo_id: lpo.lpo_id,
        },
      };

      this.$router.push(route_obj);
    },

    getAreaList() {
      const lpo = this.actLpoList[0];

      const fo_id = lpo.fo_id;
      const region_id = lpo.region_id;
      const forestry_id = lpo.forestry_id;
      const localforestry_id = lpo.localforestry_id;
      const subforestry_id = lpo.subforestry_id;

      const form = new FormData();
      form.append("fo_id", fo_id);
      form.append("region_id", region_id);
      form.append("forestry_id", forestry_id);
      form.append("localforestry_id", localforestry_id);
      form.append("subforestry_id", subforestry_id ? subforestry_id : "0");

      return fetch(GET_AREAS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          this.areaList = res;
        })
        .catch((err) => console.log(err));
    },

    getSectionList() {
      const locality_id = this.selectedArea.id;

      const form = new FormData();
      form.append("locality_id", locality_id);

      return fetch(GET_SECTIONS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          this.sectionList = res;
        })
        .catch((err) => console.log(err));
    },

    createLpo() {
      if (!this.selectedArea || !this.selectedSection) {
        console.log("no area or section");
        return;
      }

      if (
        this.isLpSection &&
        (this.selectedSectionLp === null || this.selectedSectionLp === "")
      ) {
        console.log("no section lp");
        return;
      }

      const json_obj = [
        {
          i: {
            tab: [
              {
                tab_name: "data_lpo",
                f_v: {
                  tax_id: this.selectedSection.id,
                  section_lp: this.isLpSection ? this.selectedSectionLp : null,
                  lease_id: this.actLpoList[0].lease_id,
                  user_id: this.$store.state.auth.userId,
                  engineer_id: this.$store.state.auth.userId,
                },
              },
            ],
          },
        },
      ];

      const json_str = JSON.stringify(json_obj);
      // console.log(json_str);
      // return;

      processJSON(json_str).then((res) => {
        this.getActLpoList();
      });
    },

    ...mapActions("lpoData", ["getActLpoList", "removeLpoFromList"]),
  },
};
</script>

<style scoped src="@/style/wrapper.css"></style>
<style scoped src="@/style/grid.css"></style>
<style scoped src="@/style/input.css"></style>

<style scoped>
.btn-row {
  margin-bottom: 20px;
}

.control-btn-row > button {
  margin-right: 10px;
}

.add-block {
  background-color: #eee;
  padding: 20px 20px;
  border: 1px solid #ccc;
  margin-bottom: 20px;
}

.add-block-btn-row {
  margin-top: 10px;
}

.lpos-data {
  padding-top: 30px;
}

.title-block {
  font-size: 20px;
  font-family: "roboto black";

  margin-bottom: 40px;
}

.lpos-table {
  width: 100%;
  font-size: 14px;
}

.lpos-table th {
  font-weight: bold;
  padding: 6px;
}

.lpos-table td {
  border-top: 1px solid #aaa;
  padding: 6px;
  text-align: center;
  vertical-align: middle;
}
</style>
